import { Box, Button, Card, Typography, useTheme } from "@mui/material";
import React from "react";
import pending from "../../assets/pending.png";
import backicon from "../../assets/backwidget.png";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PaymentPending = ({Css}) => {
  const theme=useTheme()
  const widgetData = JSON.parse(localStorage?.getItem("widget"));
  const navigate = useNavigate();
  const deviceId = JSON.parse(localStorage.getItem("deviceId"));
  const { languageWords } = useSelector((store) => store?.addGuest);
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        textAlign: "center",
        backgroundColor: Css?.SucessbgClr,
        p: { xs: 1, sm: 2, md: 3 }, // Responsive padding
      }}
    >
      {/* Main content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            width: { xs: "60px", sm: "100px", md: "100px" }, // Responsive width
            height: { xs: "60px", sm: "100px", md: "100px" }, // Responsive height
            mb: 2,
          }}
        >
          <img
            src={pending}
            alt="failed-img"
            style={{ width: "100%", height: "100%" }}
          />
        </Box>

        <Typography
          sx={{
            color:Css?.SucessHeadingClr,
            fontSize: { xs: "24px", sm: "30px", md: "36px" }, // Responsive font size
            fontWeight: 600,
            textAlign: "center",
            mb: 1,
          }}
        >
          {languageWords?.PaymentPendingMessage}
        </Typography>

        <Typography
          sx={{
            color: Css?.SuccessInfoClr,
            fontSize: { xs: "12px", sm: "14px", md: "16px" }, // Responsive font size
            textAlign: "center",
            maxWidth: "600px", // Limit text width for better readability
            mb: 3,
          }}
        >
          {languageWords?.PaymentPendingInfo}
        </Typography>
      </Box>

      {/* Bottom buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "space-between" },
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          width: "100%",
          maxWidth: "1000px", // Keep buttons aligned within the main container's width
          mb: 2, // Margin from the bottom of the viewport
          px: 3,
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            window.history.back();
          }}
          sx={{
            backgroundColor:Css?.failureBackBtnBg,
            color: Css?.failureBackTxt,
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            mb: { xs: 2, sm: 0 }, // Margin for vertical stacking on small screens
          }}
        >
          <img src={backicon} alt="back-img" style={{ marginRight: "8px" }} />
          {languageWords?.GoBack}
        </Button>

        <Button
          sx={{
            backgroundColor: Css?.startAgainBtnBg,
            color:Css?.startAgainBtnTxt,
            fontSize: "12px",
          }}
          onClick={() => {
            let url = `/widget?widgetsetupid=${widgetData?.id}&key=${widgetData?.key}&resType=${widgetData?.resType}`;
            if (deviceId && deviceId != "null") {
              url += `&deviceId=${encodeURIComponent(deviceId)}`;
              window.location.href = url;
            } else {
              window.parent.postMessage(
                {
                  redirectUrl: `/`,
                },
                "*"
              );
            }
          }}
        >
          {languageWords?.StartAgain}
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentPending;
